var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Routes, Outlet } from 'react-router-dom';
import TalentForm from '../TalentPage/TalentForm/TalentForm';
import BlastIndex from './Blast/Blast';
// import BlastForm from './BlastForm/BlastForm'
var BlastPage = function () {
    return (_jsx(Routes, { children: _jsxs(Route, __assign({ element: _jsx(Outlet, {}) }, { children: [_jsx(Route, { path: '', element: _jsx(BlastIndex, {}) }), _jsx(Route, { path: '/add', element: _jsx(TalentForm, {}) }), _jsx(Route, { path: '/edit/:id', element: _jsx(TalentForm, {}) })] })) }));
};
export default BlastPage;
